import { render, staticRenderFns } from "./ErrorsModal.vue?vue&type=template&id=d1c82284"
import script from "./ErrorsModal.vue?vue&type=script&lang=ts"
export * from "./ErrorsModal.vue?vue&type=script&lang=ts"
import style0 from "./ErrorsModal.vue?vue&type=style&index=0&id=d1c82284&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports